import { cn } from '@nesso/ui/lib/utils';
import { Avatar, AvatarFallback } from '@nesso/ui/primitives/avatar';

type UserAvatarProps = {
    name?: string | null;
    className?: string;
};

export function UserAvatar({ name, className }: UserAvatarProps) {
    return (
        <Avatar className={cn('h-8 w-8 cursor-pointer', className)}>
            <AvatarFallback className="bg-secondary-background text-secondary-text">
                {name?.[0]?.toUpperCase() || ''}
            </AvatarFallback>
        </Avatar>
    );
}
